import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/deskpro': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M205.9 512l31.1-38.4c12.3-0.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-0.1-5-0.8-4.4-28.9-37.4h79.1c-0.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zM406.3 344.3l-119.2 0.1 17.4-31.3 175.5 0.3c-15.2 17.3-35.1 30.9-73.7 30.9zM362.7 120.4v168.3h-73.5l-32.7 55.5h-6.5c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114v-213.3c0-16 9.7-16.6 15-16.8h82c0.2 0 0.3 0.1 0.5 0.1 4.3-0.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-0.4 126.5 79.4 126.5 120.2zM230.2 176.4l64 29.3c13.3-45.5-42.2-71.7-64-29.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/deskpro.js
// module id = 789
// module chunks = 0